import React, { useState, useContext } from "react";
import { GlobalContext } from "../context/GlobalContext";

const CardTypeForm = () => {
  const { cardType, toggleCardTypeForm, updateCardType } =
    useContext(GlobalContext);

  const [cardTypeTemp, setCardTypeTemp] = useState(cardType);

  const locationGoBackHandle = () => {
    toggleCardTypeForm();
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    updateCardType({ cardType: cardTypeTemp });
    toggleCardTypeForm();
  };

  return (
    <form className="gog-search-form" onSubmit={handleFormSubmit}>
      <div className="gog-inline-form-row gog-field">
        <label>Card Type</label>

        <select
          onChange={(e) => setCardTypeTemp(e.target.value)}
          value={cardTypeTemp}
        >
          <option>Standard</option>
          <option>Mother's Day Card</option>
          <option>Valentine's Day Card</option>
        </select>
      </div>

      <div className="gog-form-actions">
        <button
          type="button"
          onClick={locationGoBackHandle}
          className="gog-light-btn"
        >
          Back
        </button>

        <button type="submit" className="gog-primary-btn">
          Next
        </button>
      </div>
    </form>
  );
};

export default CardTypeForm;